const ReduxSliceNames = {
  Auth: 'Auth',
  LoadingFullScreen: 'LoadingFullScreen',
  Owner: 'Owner',
  Project: 'Project'
};

export default ReduxSliceNames;
